import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';

// Core layout components remain statically imported so they load instantly
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { Analytics } from '@vercel/analytics/react';
import SubmitAchievement from './pages/SubmitAchievement';
import AdminDashboard from './pages/AdminDashboard';
import AdminTerminal from './components/AdminTerminal';

// Lazy load page routes to split the large bundle file into smaller pieces
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Achievements = lazy(() => import('./pages/Achievements'));
const Campus = lazy(() => import('./pages/Campus'));
const Contact = lazy(() => import('./pages/Contact'));
const OurStaff = lazy(() => import('./pages/OurStaff'));
const NotFound = lazy(() => import('./pages/NotFound'));

// Placeholder components for routes not yet fully implemented
const Placeholder = ({ title }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <h1 className="text-3xl font-bold text-[#1e3a8a]">{title} Page Coming Soon</h1>
  </div>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="font-sans antialiased text-gray-900 bg-white min-h-screen flex flex-col">
        {/* Navigation Bar - Sticky across all pages */}
        <Navbar />

        {/* Main Content Area wrapped in Suspense to handle the brief loading state */}
        <main className="flex-grow">
          <Suspense fallback={
            <div className="min-h-[60vh] flex items-center justify-center bg-white">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#1e3a8a]"></div>
            </div>
          }>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />

              <Route path="/achievements" element={<Achievements />} />
              <Route path="/achievements/submit" element={<SubmitAchievement />} />
              <Route path="/admin" element={<AdminTerminal />} />

              <Route path="/campus" element={<Campus />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/staff" element={<OurStaff />} />
              
              {/* 404 Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </main>

        <Footer />
        <Analytics />
      </div>
    </Router>
  );
}

export default App;